if (!customElements.get("teams-slider")) {
  customElements.define(
    "teams-slider",
    class TeamsSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderRef = this.querySelector("[data-slider]");
        this.nextRef = this.querySelector('[data-navigation="next"]') || null;
        this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
        this.paginationRef = this.querySelector("[data-pagination]") || null;
        this.initSlider = this.initSlider.bind(this);
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        this.swiper = new Swiper(this.sliderRef, {
          // Optional parameters
          loop: false,
          autoplay: false,
          slidesPerView: 3,
          spaceBetween: 8,

          keyboard: {
            enabled: true,
          },

          // If we need pagination
          pagination: {
            el: this.paginationRef,
            clickable: true,
          },

          // Navigation arrows
          navigation: {
            nextEl: this.nextRef,
            prevEl: this.previousRef,
          },
        });
      }

      disconnectedCallback() {
        this.swiper.destroy();
      }
    }
  );
}
